'use strict';

// fix this
module.exports = data => {
  if (data.juicePricesRemoved) {
    return;
  }

  data.multiOption.forEach(option => {
    Object.assign(option, {
      pricing: Object.assign(option.pricing, {
        formattedDiscount: '85% off',
        formattedPrice: option.pricing.urgencyPricing.formattedOldPrice,
        formattedValue: '$1,000',
        urgencyPricing: undefined,
      }),
      isUrgencyPricing: false,
      showDoubleStrikeThroughPrice: false,
    });
  });

  data.juicePricesRemoved = true;
};
